import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CrmWidget" */ './CrmWidget'),
  modules: ['./CrmWidget'],
  loading: () => null
});

export default LoadableWidget;
